const blank = require('./blank');

/** OAuth 回调：保持与 /blank 相同的 body（鲲穹页头/页尾），仅触发一次鉴权 */
module.exports = function oauthRoute(state, emit) {
  if (typeof window !== 'undefined' && state.query.code && !state.oauthAuthDispatched) {
    state.oauthAuthDispatched = true;
    queueMicrotask(() => {
      emit('authenticate', state.query.code, state.query.state);
    });
  }
  return blank(state, emit);
};
